module.exports = __webpack_public_path__ + "img/edicion.c6384fc8.png";